'use client'

import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'

export default function ActionWorldCardSkeleton({ className }: { className?: string }) {
  return (
    <motion.div
      className={cn(
        'text-card-foreground cursor-wait rounded-lg border-0 bg-transparent shadow-xs',
        className,
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="group/card flex aspect-[1.72] w-full flex-col items-center gap-4 align-middle lg:mb-2">
        <Skeleton className="size-full rounded-lg bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10" />
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-40 rounded-lg bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10" />
          <div className="flex justify-between">
            <Skeleton className="h-4 w-20 rounded-lg bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10" />
            <div className="flex gap-2">
              <Skeleton className="h-4 w-12 rounded-lg bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10" />
              <Skeleton className="size-4 rounded-lg bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}
